<template>
    <CookieWarning v-if="currentLanguage === 'translated'" :section_title="section_title_translated" :cookie_policy="cookie_policy_translated"/> 
    <CookieWarning v-else :section_title="section_title_en" :cookie_policy="cookie_policy_en"/>

</template>

<script>
import axios from 'axios';
import CookieWarning from '@/components/CookieWarning.vue';

export default {
    components: {
        CookieWarning
    },
    data() {
        return {
            cookieData: {
                items_translated: [{ section_title: '', cookie_policy: '' }],
                items_en: [{ section_title: '', cookie_policy: '' }],
            },
            section_title_translated: '',
            section_title_en: '',
            cookie_policy_translated: '',
            cookie_policy_en: '',

        }
    },
    computed: {
        currentLanguage() {
            return this.$store.getters.getCurrentLanguage;
        },
    },
    created() {
        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    },
    mounted() {
        const token = process.env.VUE_APP_WEBSITE_TOKEN;
        const API_URL = process.env.VUE_APP_WEBSITE_HOSTNAME;

        axios.get(`${API_URL}/api/cookie-policy-content`, {
            headers: {
                'Authorization': `Token ${token}`,
            },
        })
            .then(response => {
                this.cookieData = response.data || { items_translated: [], items_en: [] };

                if (this.cookieData && (this.cookieData.items_translated.length > 0 || this.cookieData.items_en.length > 0)) {
                    const translatedItem = this.cookieData.items_translated[0];
                    const enItem = this.cookieData.items_en[0];

                    if (translatedItem && translatedItem.active === true) {
                        this.section_title_translated = translatedItem.section_title;
                        this.cookie_policy_translated = translatedItem.cookie_policy;
                    }

                    if (enItem && enItem.active === true) {
                        this.section_title_en = enItem.section_title;
                        this.cookie_policy_en = enItem.cookie_policy;
                    }
                }

                
            })
            .catch(error => {
                console.error('Error fetching cookie warning data:', error);
            });


        const savedLanguage = localStorage.getItem("currentLanguage");
        if (savedLanguage) {
            this.$store.dispatch("toggleLanguage");
        }
    }
}
</script>

<style></style>